import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Language } from '../../app/slices/customizations.slice';

interface Props {
	onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
	open: boolean;
	src: string;
	language: Language;
}

const LanguageSelectContainer: FC<Props> = ({ onClick, open, src, language }) => {
	const { t } = useTranslation();

	return (
		<button
			type="button"
			id="language-container"
			className="reset-button language-link-2"
			aria-controls={open ? 'language-menu' : undefined}
			aria-haspopup="true"
			aria-expanded={open ? 'true' : undefined}
			aria-label={t('a11y.change-language')}
			onClick={onClick}
			style={{ display: 'flex' }}
		>
			<img id={language + '-flag'} className="language-flag" src={src} alt="" aria-hidden="true" />
			<span style={{ paddingLeft: '5px' }}>{t('footer.language')}</span>
		</button>
	);
};

export default LanguageSelectContainer;
